import {BUILD_CHANGED_STATUS} from '../../../../../utils/subscriptionEvents'

export const SELECTED_BUILD_DEPENDENCY_ID_PARAM = 'pageFullLogBuildId'

export const BUILD_EVENT_TYPES = [BUILD_CHANGED_STATUS]
